<template>
  <div>
    <v-row class="pa-3 pb-0" no-gutters align="center">
      <v-col cols="2">Date</v-col>
      <v-col cols="2">OrderId</v-col>
      <v-col cols="4">Customer</v-col>
      <v-col class="d-flex justify-end pr-3">Order total</v-col>
      <v-col cols="1" class="d-flex justify-end">
        Details
      </v-col>
    </v-row>
    <v-progress-linear v-if="loading" :indeterminate="!loading" height="1" color="secondary" class="my-1">
    </v-progress-linear>
    <v-divider v-else class="my-1"></v-divider>

  </div>
</template>


<script>

export default {
  name: 'ContractOrderCardHeader',
  props: {
    loading: Boolean,
  },
  components: {},
  mixins: [],

  data() {
    return {

    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>
